import * as React from 'react';
import { NavLink, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Container, Menu } from 'semantic-ui-react';

import { DescriptorDeUsuario } from 'src/descriptor';
import DatosDeContacto from './paginas/DatosDeContacto';
import FichaDeAlumno from './paginas/FichaDeAlumno';
import ListaGeneral from './paginas/ListaGeneral';
import Restringidos from './paginas/Restringidos';

export function puedeVerFichaDeAlumno(usuario: DescriptorDeUsuario) {
    return usuario.tieneAlgunaDeEstasFunciones(
        'asesor',
        'asistente_matriculas',
        'supervisor',
        'inscriptor_cursos',
        'administrador_cursos',
        'recaudador',
        'coordinador',
        'recepcionista',
        'encargado_docente',
        'orientador',
        'administrativo',
        'psicopedagogo',
    );
}
const Alumnos = (props: RouteComponentProps<{}>) => {
    const rutaBase = props.match.url;

    const rutas = {
        listaGeneral: rutaBase,
        restringidos: rutaBase + '/restringidos',
        fichaDelAlumno: rutaBase + '/:numeroDeMatricula',
        contactos: rutaBase + '/contactos',
    };

    return (
        <Container>
            <Menu pointing secondary>
                <Menu.Item exact as={NavLink} to={rutas.listaGeneral} content='Lista general' />
                <Menu.Item as={NavLink} to={rutas.restringidos} content='Restringidos' />
                <Menu.Item as={NavLink} to={rutas.contactos} content='Datos de contacto' />
            </Menu>

            <Route
                exact
                path={rutas.listaGeneral}
                children={({ match }) => <ListaGeneral ocultar={!match} />}
            />

            <Switch>
                <Route path={rutas.restringidos} component={Restringidos} />
                <Route path={rutas.contactos} component={DatosDeContacto} />
                <Route path={rutas.fichaDelAlumno} component={FichaDeAlumno} />
            </Switch>
        </Container>
    );
};

export default Alumnos;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/index.tsx